import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {PfDropdown} from '@profabric/react-components';

export const StyledDropdown = styled(PfDropdown)`
  border: none;
  width: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  --pf-dropdown-menu-min-width: 10rem;

  .dropdown-item {
    padding: 0.5rem 1rem;
  }

  .text-sm {
    margin-bottom: 0;
  }
  .dropdown-divider {
    margin: 0;
  }
`;

const NotificationsDropdown = () => {
  const [t] = useTranslation();

  return (
    <StyledDropdown hideArrow>
      <div slot="button">
        <i className="far fa-bell" />
        {/*<span className="badge badge-warning navbar-badge">15</span>*/}
      </div>
      <div slot="menu">
        <span className="dropdown-item dropdown-header">
          {t<string>('header.notifications.count', {quantity: '0'})}
        </span>
        <div className="dropdown-divider" />
        <div className="dropdown-divider" />
      </div>
    </StyledDropdown>
  );
};

export default NotificationsDropdown;
